import { BannerConfig } from '../addi-product-banner/addi-product-banner.d';
import { Builder } from './content-builder.d';
import { Template } from './templates/types';

import { BNPLWidgetBR } from './templates/bnpl';
import { BNPLBNPNWidgetBR } from './templates/bnpl-bnpn';
import { BNPLWidgetBR4x } from './templates/bnpl-4x';

const defaultBuilder: Builder = {
  build: BNPLWidgetBR,
};

const templateBuilder: { [key in Template]?: Builder } = {
  [Template.ADDI_BNPL_DEFAULT]: {
    build: BNPLWidgetBR,
  },
  [Template.ADDI_TEMPLATE_01]: {
    build: BNPLWidgetBR,
  },
  [Template.ADDI_TEMPLATE_02]: {
    build: BNPLBNPNWidgetBR,
  },
  [Template.ADDI_TEMPLATE_03]: {
    build: BNPLWidgetBR,
  },
  [Template.ADDI_TEMPLATE_04]: {
    build: BNPLBNPNWidgetBR,
  },
  [Template.ADDI_TEMPLATE_4X]: {
    build: BNPLWidgetBR4x,
  },
};

export const bannerBuilder = (
  template: Template,
  config: BannerConfig
): HTMLElement => {
  const builder: Builder = templateBuilder[template] ?? defaultBuilder;

  return builder.build(config);
};
